

import { getPeerGroupData, IFilter, IPeerGroupTabsProps } from "../../lib/http";
import * as React from 'react'
import { Panel, Table } from "react-bootstrap";

interface IFoundationDistributionTableState {
  loading: boolean
  rows: any[]
  data: any[]
  title: string
  filters: IFilter
}


export class FoundationDistributionTable extends React.Component<IPeerGroupTabsProps, IFoundationDistributionTableState> {
  state: IFoundationDistributionTableState = {
    loading: false,
    rows: [],
    data: [],
    title: '',
    filters: { assetLevel: 0 }
  }


  componentDidMount() {
    this.loadSeries(this.props.filters)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filters.assetLevel !== this.props.filters.assetLevel || prevProps.data.length !== this.props.data.length) {
      this.setState({ filters: this.props.filters, data: this.props.data }, () => {
        this.loadSeries(this.props.filters)
      })
    }
  }

  loadSeries(filters: IFilter) {
    const { data } = this.state

    const currentSet = data.find(dataPoint => dataPoint.filterId === filters.assetLevel)

    const rows = []
    if (currentSet) {
      rows.push([currentSet.IncCon_T_B_IncConLevelName1, parseInt(currentSet.IncCon_N_D_IncConLevelCount1).toLocaleString('en'), currentSet.IncCon_T_B_IncConLevelValue1, currentSet.IncCon_T_B_IncConLevelAvg1])
      rows.push([currentSet.IncCon_T_B_IncConLevelName2, currentSet.IncCon_N_D_IncConLevelCount2.toLocaleString('en'), currentSet.IncCon_T_B_IncConLevelValue2, currentSet.IncCon_T_B_IncConLevelAvg2])
      rows.push([currentSet.IncCon_T_B_IncConLevelName3, currentSet.IncCon_N_D_IncConLevelCount3.toLocaleString('en'), currentSet.IncCon_T_B_IncConLevelValue3, currentSet.IncCon_T_B_IncConLevelAvg3])
      rows.push([currentSet.IncCon_T_B_IncConLevelName4, currentSet.IncCon_N_D_IncConLevelCount4.toLocaleString('en'), currentSet.IncCon_T_B_IncConLevelValue4, currentSet.IncCon_T_B_IncConLevelAvg4])
      rows.push([currentSet.IncCon_T_B_IncConLevelName5, currentSet.IncCon_N_D_IncConLevelCount5.toLocaleString('en'), currentSet.IncCon_T_B_IncConLevelValue5, currentSet.IncCon_T_B_IncConLevelAvg5])
      rows.push([currentSet.IncCon_T_B_IncConLevelName6, currentSet.IncCon_N_D_IncConLevelCount6.toLocaleString('en'), currentSet.IncCon_T_B_IncConLevelValue6, currentSet.IncCon_T_B_IncConLevelAvg6])
      rows.push([currentSet.IncCon_T_B_IncConLevelNameTotal, parseInt(currentSet.IncCon_N_D_IncConLevelCountTotal).toLocaleString('en'), currentSet.IncCon_T_B_IncConLevelValueTotal, currentSet.IncCon_T_B_IncConLevelAvgTotal])
    }

    const title = currentSet ? currentSet['IncCon_T_B_IncomingAvgVal'] : ''
    this.setState({ title, rows })

  }

  render() {
    const { rows, loading, title } = this.state
    return (
      <Panel>
        {title !== '' &&
          <div className="panel-heading text-center">
            <b>{title}{loading && <i className="fa fa-cog fa-spin"></i>}</b>
          </div>
        }
        <div className="panel-body">
          <Table striped>
            <thead>
              <tr>
                <th>Incoming Contribution Level</th>
                <th className="text-center">Number of Foundations</th>
                <th className="text-center">Total Amount</th>
                <th className="text-center">Average Amount</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((item, index) => {
                let rowStyle = {}
                if (item[0] === 'Total') rowStyle = { fontSize: '1.6rem', fontWeight: 'bold' }
                return (
                  <tr key={`distributionrow` + index} style={rowStyle}>
                    {item.map((column, columnIndex) => {

                      const style = columnIndex !== 0 ? { textAlign: 'right' } : {}
                      return (
                        <td style={style} key={`distributioncolumn` + columnIndex}>{column}</td>
                      )
                    })}
                  </tr>
                )
              })}
            </tbody>
          </Table>
        </div>
      </Panel>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/components/visualizations/PeerGroups/IncomingContributions/FoundationDistributionTable/index.tsx